import * as yup from 'yup';
import ValidationMessage from '../../constants/ValidationMessage';

const ContactUsValidation = yup.object().shape({
    name: yup.string()
        .required(ValidationMessage.Field("name"))
        .max(50, ValidationMessage.MaxLength('name', 50))
        .matches(/^[a-zA-Z\s]+$/, ValidationMessage.OnlyAlphabets('name'))
        .trim(),

    subject: yup.string()
        .required(ValidationMessage.Field("subject"))
        .trim(),

    email: yup.string().required(ValidationMessage.Field("email"))
        .email(ValidationMessage.EMAIL_ADDRESS)
        .matches(ValidationMessage.EMAIL_REGREX, ValidationMessage.EMAIL_ADDRESS)
        .max(150, ValidationMessage.MaxLength('Email', 150))
        .trim(),

    description: yup.string()
        .max(150, ValidationMessage.MaxLength('Description', 1000))
        .trim(),
});

export default ContactUsValidation;

